"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class DataRequestLink extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dataRequestLink';
        this._dataRequestId = initParams.data_request_id;
        this._expiresTime = initParams.expires_time;
        this._url = initParams.url;
        this._expires = initParams.expires;
    }
    set dataRequestId(value) {
        console.error('Do not set objects this way');
    }
    get dataRequestId() {
        return this._dataRequestId;
    }
    set expiresTime(value) {
        console.error('Do not set objects this way');
    }
    get expiresTime() {
        return this._expiresTime;
    }
    set url(value) {
        console.error('Do not set objects this way');
    }
    get url() {
        return this._url;
    }
    set expires(value) {
        console.error('Do not set objects this way');
    }
    get expires() {
        return this._expires;
    }
}
exports.default = DataRequestLink;
//# sourceMappingURL=dataRequestLink.js.map